export default "__VITE_ASSET__DYUiY4ed__"